function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { getMediaTypeFromUrl } from '../utils/media';
/**
 * 미디어 표시 계산 훅
 * 
 * 표시할 미디어, 숨길 미디어 등 계산 로직을 제공합니다.
 */ export function useDisplayMedia() {
    var images = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], videos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], shortFormVideos = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    // 미디어 URL 패턴으로 숏폼 비디오 감지
    var isShortFormByUrl = function(url) {
        var shortFormPatterns = [
            'shorts',
            'reels',
            'tiktok',
            'vertical',
            'portrait',
            'instagram.com/reel',
            'vm.tiktok',
            'youtube.com/shorts'
        ];
        return shortFormPatterns.some(function(pattern) {
            return url.toLowerCase().includes(pattern);
        });
    };
    // 숏폼으로 명시적으로 지정된 비디오 또는 URL 패턴으로 감지된 비디오
    var autoDetectedShortFormVideos = videos.filter(function(video) {
        return shortFormVideos.includes(video) || isShortFormByUrl(video);
    });
    // 일반 비디오 (숏폼이 아닌 비디오)
    var normalVideos = videos.filter(function(video) {
        return !shortFormVideos.includes(video) && !isShortFormByUrl(video);
    });
    // 비디오가 있는지 확인
    var hasNormalVideo = normalVideos.length > 0;
    var hasShortFormVideo = autoDetectedShortFormVideos.length > 0;
    var hasImage = images.length > 0;
    // 복합 미디어 여부 확인 (여러 타입이 섞여 있는 경우)
    var isComplexMixedMedia = hasNormalVideo && hasShortFormVideo || hasNormalVideo && hasImage || hasShortFormVideo && hasImage;
    // 최적화된 미디어 배열 (우선순위: 일반 비디오 > 숏폼 비디오 > 이미지)
    var allMedia = _to_consumable_array(normalVideos).concat(_to_consumable_array(autoDetectedShortFormVideos), _to_consumable_array(images));
    // 각 미디어의 타입을 미리 판별 (중복 계산 방지)
    var mediaTypes = allMedia.map(getMediaTypeFromUrl);
    // 미디어 타입 캐시 확인 헬퍼
    var getMediaDisplayType = function(mediaUrl) {
        var index = allMedia.findIndex(function(url) {
            return url === mediaUrl;
        });
        return index !== -1 ? mediaTypes[index] : getMediaTypeFromUrl(mediaUrl); // fallback
    };
    // 미디어 타입에 따라 최대 표시 개수 결정
    var maxDisplay = 4;
    if (isComplexMixedMedia && hasNormalVideo) {
        // 복합 미디어 & 일반 비디오 포함 -> 3개로 제한 (1 + 2 레이아웃)
        maxDisplay = 3;
    } else if (hasNormalVideo && allMedia.length > 4) {
        // 일반 비디오 포함 & 5개 이상 -> 3개로 제한 (1 + 2 레이아웃)
        maxDisplay = 3;
    }
    // 최대 maxDisplay개까지만 표시
    var displayMedia = allMedia.slice(0, maxDisplay);
    var hasHiddenMedia = allMedia.length > maxDisplay;
    var hiddenMedia = allMedia.slice(maxDisplay);
    var hiddenCount = allMedia.length - maxDisplay;
    // 오버플로우 정보 계산
    var displayedNormalVideos = displayMedia.filter(function(media) {
        return normalVideos.includes(media);
    }).length;
    var displayedShortFormVideos = displayMedia.filter(function(media) {
        return autoDetectedShortFormVideos.includes(media);
    }).length;
    var displayedImages = displayMedia.filter(function(media) {
        return images.includes(media);
    }).length;
    var hiddenNormalVideos = Math.max(0, normalVideos.length - displayedNormalVideos);
    var hiddenShortFormVideos = Math.max(0, autoDetectedShortFormVideos.length - displayedShortFormVideos);
    var hiddenImages = Math.max(0, images.length - displayedImages);
    return {
        allMedia: allMedia,
        displayMedia: displayMedia,
        hiddenMedia: hiddenMedia,
        hiddenCount: hiddenCount,
        hiddenNormalVideos: hiddenNormalVideos,
        hiddenShortFormVideos: hiddenShortFormVideos,
        hiddenImages: hiddenImages,
        isComplexMixedMedia: isComplexMixedMedia,
        normalVideos: normalVideos,
        shortFormVideos: autoDetectedShortFormVideos,
        mediaTypes: mediaTypes,
        getMediaDisplayType: getMediaDisplayType
    };
}
export default useDisplayMedia;
